export const errors = {
  noEditorExist: 'Editor does not exist',
  B2BTokenRequestFailed:
    "Error trying to fetch partner's resources . Contact the administrator.",
  emailConfirmCodeIncorrect: 'Incorrect confirmation code from e-mail',
  authenticatorConfirmIncorrect: 'Incorrect code from the authenticator app',
  invalidPassword: 'Invalid password',
  flowCriterionCodeNotUnique: 'A criterion with this code already exists',
  flowCriterionValueCodeNotUnique:
    'A value with this code already exists in this criterion',
  notAllFlowCriteriaProvided: 'All criteria must be provided to change order',
  notAllFlowCriterionValuesProvided:
    'All criterion values must be provided to change order',
  flowCriterionHasDependents:
    'Values of other criteria depend on this criterion. Remove those dependencies first',
  flowCriterionValueHasDependents:
    'Other values depend on this value. Remove those dependencies first',
}
